import React from "react";
import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { uploadSubtitle } from "../store/actions/uploadMediaAction";
import { toast } from "react-toastify";
import { jwplayerRequest, uploadFileToLink } from "../services/jwplayer";
import { addSubtitle, deleteSubtitle, getSubtitles } from "../services/mediaTracks";
import TrackUploader from "./TrackUploader";

const SUBTITLE_LANGUAGES = [
  { value: "English en", label: "English (en)" },
  { value: "French fr", label: "French (fr)" },
  { value: "Espanish es", label: "Espanish (es)" },
];

const UploadSubtitle = ({
  media_id,
  mediaObjId,
  disableProp,
  generalContentObject,
  addURL,
  deleteURL,
  getURL,
}) => {
  // console.log("media", media_id);
  // console.log("mediaObjId", mediaObjId);
  const dispatch = useDispatch();

  const [isDisabled, setIsDisabled] = useState(disableProp);
  const [subtitlesList, setSubtitlesList] = useState([]);
  const [disableSubmitButton, setDisableSubmitButton] = useState(false);
  const [disableCancelButton, setDisableCancelButton] = useState(false);
  useEffect(() => {
    setIsDisabled(disableProp);
    setTimeout(() => {
      getSubtitles(getURL, mediaObjId).then((result) => {
        setSubtitlesList(result.subtitles);
      });
    }, 2000);
  }, [disableProp, generalContentObject, mediaObjId, getURL]);

  const { t } = useTranslation();
  const [selectedOption, setSelectedOption] = useState("defaultsubtitle");

  const inpContainer = useRef(null);
  const [subSelect, setsubSelect] = useState(false);
  const [subtitleFile, setSubtitleFile] = useState(null);
  const [showError, setShowError] = useState(false);

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);

    setsubSelect(true);
    console.log("selectedOptionn", selectedOption);
  };

  const handleFileChange = (e) => {
    setDisableSubmitButton(false);
    const file = e.target.files[0];
    const allowedExtensions = ["vtt"];

    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        e.target.value = "";
        setDisableSubmitButton(true);
        setShowError(true);
        setTimeout(() => {
          setShowError(false);
        }, 3000);

        return;
      }

      setSubtitleFile(file);
    }
  };

  const handleCancel = () => {
    setSelectedOption("defaultsubtitle");
    setsubSelect(false);
    setSubtitleFile(null);
    setDisableSubmitButton(false);
  };

  const uploadSubtitleTrack = async () => {
    if (subtitleFile !== null) {
      console.log("selectedOptionn", selectedOption);
      setDisableSubmitButton(true);
      setDisableCancelButton(true);
      // console.log("media id prop: ", media_id);
      toast.success(t("Uploading Subtitle File!"), {
        progressStyle: { background: "var(--iq-primary)" },
      });
      var jwData = {
        upload: {
          mime_type: "text/plain",
          method: "direct",
          auto_publish: true,
          file_format: "vtt",
        },

        metadata: {
          label: selectedOption.split(" ")[0],
          srclang: selectedOption.split(" ")[1],
          track_kind: "subtitles",
        },
      };

      var data = {
        body: jwData,
        url: `/media/${media_id}/text_tracks/`,
        method: "post",
        jw_tag: false,
      };
      console.log("jw data: ", data);
      await jwplayerRequest(data)
        .then(async (onJwSuccess) => {
          console.log("jw success: ", onJwSuccess);

          var track_id = onJwSuccess.data.data.id;

          var meta_data = onJwSuccess.data.data.metadata;

          // console.log("meta data: ", meta_data);

          var apiData = {
            track_id: track_id,
            language: meta_data.label,
            track_kind: onJwSuccess.data.data.track_kind,
            language_code: meta_data.srclang,
            // delivery_url: onJwSuccess.data.delivery_url,
          };
          console.log("apiData", apiData);

          var fileUploaded = await uploadFileToLink(
            // subtitleUploadLink,
            onJwSuccess.data.data.upload_link,
            subtitleFile,
            "text/plain"
          );
          // console.log(fileUploaded);
          if (!fileUploaded) {
            console.log("subtitle file not uploaded:");
            toast.error("Subtitle file not uploaded!", {
              progressStyle: { background: "var(--iq-primary)" },
            });
          } else {
            addSubtitle(addURL, mediaObjId, apiData)
              .then((onAudioCreate) => {
                // console.log("subtitle created: ", onAudioCreate.data);
                dispatch(uploadSubtitle(onAudioCreate));
                toast.success("Subtitle File Submitted Successfully!", {
                  progressStyle: { background: "var(--iq-primary)" },
                });
                setSelectedOption("defaultsubtitle");
                setsubSelect(false);
                setDisableSubmitButton(false);
                setDisableCancelButton(false);
                setSubtitleFile(null);
                getSubtitles(getURL, mediaObjId).then((result) => {
                  setSubtitlesList(result.subtitles);
                });
              })
              .catch((onAudioCreateError) => {
                // console.log("on subtitle create error: ", onAudioCreateError);
                toast.error("Please Select Subtitle File!", {
                  progressStyle: { background: "var(--iq-primary)" },
                });
                setDisableSubmitButton(false);
                setDisableCancelButton(false);
              });
          }
        })
        .catch((onJwError) => {
          console.log("on jw error: ", onJwError);
          toast.error("Please Select Subtitle File!", {
            progressStyle: { background: "var(--iq-primary)" },
          });
        });
    } else {
      toast.error("Please Select Subtitle File!", {
        progressStyle: { background: "var(--iq-primary)" },
      });
    }
  };

  const handleDelete = async (subtitle_id) => {
    // console.log("subtitle_id>>>", subtitle_id);
    try {
      await deleteSubtitle(deleteURL, mediaObjId, subtitle_id);
      // console.log("deleted subtitle>>>>");
      toast.success("Subtitle File Deleted Successfully!", {
        progressStyle: { background: "var(--iq-primary)" },
      });

      getSubtitles(getURL, mediaObjId).then((result) => {
        setSubtitlesList(result.subtitles);
      });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <TrackUploader
      id="subtitle"
      chooseLabel={t("choose subtitle files")}
      languages={SUBTITLE_LANGUAGES}
      language={selectedOption}
      onLanguageChange={handleOptionChange}
      formOpen={subSelect}
      accept=".vtt"
      extensions="VTT"
      file={subtitleFile}
      onFileChange={handleFileChange}
      inputRef={inpContainer}
      showError={showError}
      disabled={isDisabled}
      disableSubmit={disableSubmitButton}
      disableCancel={disableCancelButton}
      onSubmit={uploadSubtitleTrack}
      onCancel={handleCancel}
      tracks={subtitlesList}
      onDelete={handleDelete}
      deleteQuestion={(language) =>
        t("Delete the {{language}} subtitle file?", { language })
      }
    />
  );
};

export default React.memo(UploadSubtitle);
